let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a6inL")).then(() => parcelRequire('2jmf2'));